import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { createCompany, myInvitationsApi } from "../api";

export default function CreateCompany() {
  const navigate = useNavigate();
  const { user, company, refresh } = useAuth();
  const [name, setName] = useState("");
  const [salary, setSalary] = useState(500000);
  const [weekType, setWeekType] = useState(5);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [pendingInvites, setPendingInvites] = useState(0);

  // If user already has a company — bounce back to dashboard
  useEffect(() => {
    if (company?.company_id) {
      navigate("/dashboard", { replace: true });
    }
  }, [company, navigate]);

  // Show pending invitations hint
  useEffect(() => {
    (async () => {
      try {
        const list = await myInvitationsApi();
        setPendingInvites(list.filter(i => i.status === "pending").length);
      } catch { /* ignore */ }
    })();
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await createCompany({ name, salary: Number(salary), week_type: Number(weekType) });
      // Google Ads conversion: Sign-up (company created)
      try {
        if (typeof window !== "undefined" && typeof window.gtag === "function") {
          window.gtag("event", "conversion", {
            send_to: "AW-18222424425/0lnrCK_zibscEOnCkPFD",
            value: 1.0,
            currency: "USD",
          });
        }
      } catch (_) { /* ignore analytics errors */ }
      await refresh();
      navigate("/dashboard");
    } catch (e2) {
      setErr(e2.response?.data?.detail || "Ошибка создания компании");
    } finally { setBusy(false); }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card" data-testid="create-company-card" style={{ maxWidth: 520 }}>
        <h3 className="fw-bold mb-1">Создание компании</h3>
        <p className="text-muted small mb-4">
          Здравствуйте, {user?.name}! Вы становитесь директором новой компании.
        </p>
        {pendingInvites > 0 && (
          <div className="alert alert-info py-2 d-flex align-items-center justify-content-between flex-wrap gap-2"
               data-testid="cc-pending-invites">
            <div>
              <i className="bi bi-envelope-paper me-1"></i>
              У вас {pendingInvites === 1 ? "есть приглашение" : `есть ${pendingInvites} приглашений`} в существующую компанию.
            </div>
            <Link to="/invitations" className="btn btn-sm btn-primary">
              Открыть приглашения
            </Link>
          </div>
        )}
        {err && <div className="alert alert-danger py-2">{err}</div>}
        <form onSubmit={onSubmit}>
          <div className="mb-3">
            <label className="form-label small">Название компании</label>
            <input className="form-control" required value={name}
                   onChange={(e) => setName(e.target.value)} data-testid="cc-name" />
          </div>
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label small">Ваш оклад (₸/мес)</label>
              <input type="number" className="form-control" min={0} value={salary}
                     onChange={(e) => setSalary(e.target.value)} data-testid="cc-salary" />
            </div>
            <div className="col-md-6">
              <label className="form-label small">Рабочая неделя</label>
              <select className="form-select" value={weekType}
                      onChange={(e) => setWeekType(e.target.value)} data-testid="cc-week">
                <option value={5}>Пятидневная</option>
                <option value={6}>Шестидневная</option>
              </select>
            </div>
          </div>
          <button className="btn btn-primary w-100 mt-4" disabled={busy} data-testid="cc-submit">
            {busy ? "Создание…" : "Создать компанию"}
          </button>
        </form>
      </div>
    </div>
  );
}
